<template>
    <div class="content_main controlpanel">
        <div style="height:90px;">
            <el-row>
                <Personal :activeName.sync="activeName"></Personal>
            </el-row>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="控制面板" name="first">
                <div class="mini_chatrs">
                    <el-row :gutter="24" style="margin-left:0;margin-right:0;margin-bottom: 20px;">
                        <el-col :span="8" style="padding-left:0;margin-right:0;height:350px;">
                            <el-card :body-style="{ padding: '0px' }" style="position: relative;border:none;"> 
                                <template>
                                    
                                    <el-tabs v-model="activeName2" type="border-card" style="height:350px;">
                                        <el-tab-pane label="通知" name="first">
                                            <ul v-for="items in newslist" :key="items.data">
                                                <li class="notice_item" v-for="item in items.noticeList" :key="item.IsLook">{{item.NoticeMsg}}</li>
                                            </ul>
                                            
                                        </el-tab-pane>
                                        <!-- <el-tab-pane label="配置管理">配置管理</el-tab-pane> -->
                                    </el-tabs>
                                </template>
                                <span class="lookmore" @click="gomessage"> 查看更多</span>
                            </el-card>
                            
                        </el-col>
                        <el-col :span="8" style="height:350px;">
                            <el-card :body-style="{ padding: '0px' }" style="position: relative;height:350px;"> 
                                <img style="height:180px;width:100%;" class="image" src="../../images/addpic_bg.png" alt="">
                                <img style="position:absolute;top:50px;left:130px;" src="../../images/addpic.png" alt="">
                                <el-row class="property_infor" style="padding: 15px 10px;">
                                    <el-row class="property_title property_infor_item" style="background:#efefef;width:300px;height:20px;"></el-row>
                                    <el-row class="property_update property_infor_item" style="background:#efefef;width:160px;height:20px;"></el-row>
                                    <el-row class="property_status property_infor_item" style="background:#efefef;width:260px;height:20px;"></el-row>
                                </el-row>
                                <el-button class="addhouseBtn" type="primary" @click="goaddhouse" style="margin: 0 auto;display: block;">添加新房源</el-button>
                            </el-card>
                        </el-col>
                        <el-col :span="8" style="margin-left:0;padding-right:0;text-align:center;height:350px;">
                            <el-card :body-style="{ padding: '30px' }" style="position: relative;height:350px;"> 
                                <img style="width:100px;margin-bottom:30px;" class="image" src="http://landlord.jrechina.com/images/jre.png" alt="">
                                <h3 style="font-size: 16px;margin-bottom:15px;">ReloChina</h3>
                                <span style="color: #ccc;font-size: 14px;">Your one-stop solution to apartment hunting and lifestyle in Shanghai</span>
                                <el-button class="addhouseBtn" type="primary" style="margin-top:18px;">进入</el-button>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24" style="border:1px solid #efefef;margin-left:0;margin-right:0;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)">
                        <el-col :span="10" style="border-right:1px solid #efefef;padding-top: 10px;">
                            <Myecharts></Myecharts>
                        </el-col>
                        <el-col :span="14" style="">
                            <h3 style="padding-top: 10px;">交易记录</h3>
                            <div>
                                <el-table
                                    :data="tableData"
                                    style="width: 100%">
                                    <el-table-column
                                        prop="C_COMName"
                                        label="消息"
                                        width="410">
                                    </el-table-column>
                                    <el-table-column
                                        prop="CreatTime"
                                        label="日期"
                                        width="80">
                                    </el-table-column>
                                </el-table>
                                <span class="lookmore" @click="activeName = 'fourth'"> 查看更多</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane label="待处理及通知" name="second">
                <Message></Message>
            </el-tab-pane>
            <el-tab-pane label="个人资料" name="third">
                <Self></Self>
            </el-tab-pane>
            <el-tab-pane label="交易记录" name="fourth">
                <Myecharts v-if="activeName == 'fourth'"></Myecharts>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Self from '@/pages/controlPanel/components/self/self.vue'
import Message from '@/pages/message/message.vue'
import Personal from '@/components/personal/personal.vue'
import Myecharts from '@/components/myecharts/myecharts.vue'
export default {
    components:{
        Self,Message,Personal,Myecharts
    },
    
    data(){
        return {
            activeName: 'first',
            activeName2: 'first',
            tableData: [],
            isData: false,
            newslist: []
        }
    },
    methods:{
        handleClick(tab, event) {
        // console.log(tab, event);
        },
        goaddhouse(){
            this.$router.push({path:'/publishHouse'});
        },
        transactionrecordlist(){
            //交易记录
            let params = {
                action:'GetNegotiatorFinancialList',
                page:1,
                row:4
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.tableData = data;
            },err => {

            })
        },
        getNoticeList(){
            var params = {
                Action: 'GetNoticeGroupByDate',
                pageSize: 5,
                pageIndex: 1,
                IsLook: 0
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.newslist = data;
            }, err => {
                
            })
        },
        gomessage(){
            this.$router.push({path:'/message'});
        }
    },
    created(){
        if(this.$route.query.tab){
            this.activeName = this.$route.query.tab || 'first';
        }
        this.transactionrecordlist();
        this.getNoticeList();        
    }
}
</script>

<style>
.controlpanel{
    width:1100px;
    padding: 25px;
   
}
.controlpanel .el-tabs__nav-wrap::after{
    height: 1px;
}
.controlpanel .mini_chatrs .charts_box_bar_box{
    height: 155px;
}
.controlpanel .mini_chatrs .charts_box_bar_box .charts_bar{
    height: 130px;
}
.controlpanel .mini_chatrs .charts_box_line_box{
    height: 180px;
}
.controlpanel .mini_chatrs .charts_box_line_box .charts_line{
    height: 150px;
}
.controlpanel .mini_chatrs .charts_box_item_total{

}
.controlpanel .el-table__header-wrapper{
    display: none;
}
.controlpanel .lookmore{
    color:#2ecc71;
    cursor: pointer;
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 14px;    
}
.property_infor .property_infor_item{
    margin-bottom: 5px;
    font-size: 14px;
}
.addhouseBtn{
        margin: 0 auto;
    margin-bottom: 20px;
    display: block;
}
.controlpanel .notice_item{
    /* margin-left: 16px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 35px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/controlPanel/controlPanel.vue